import { combineReducers } from "redux";
import dashboard from "./dashboardReducer";
import subscriptionPlans from "./subscriptionPlans";
import agencyProfile from "./agencyProfile";
import candidateRecord from "./candidateRecord";
import employerAnalytics from "./employerAnalytics";
import howToGuides from "./howToGuides";
import preferredSuppliersList from "./preferredSuppliersList";
import premiumPricing from "./premiumPricing";
import activityFeed from "./activityFeed";
import portalAgencySignUp from "./portalAgencySignUp";
import employerPendingReviews from "./employerPendingReviews";
import diversityForm from "./diversityForm";

export default combineReducers({
  dashboard,
  subscriptionPlans,
  agencyProfile,
  candidateRecord,
  employerAnalytics,
  howToGuides,
  preferredSuppliersList,
  premiumPricing,
  activityFeed,
  portalAgencySignUp,
  employerPendingReviews,
  diversityForm,
});
